import { FC } from 'react';
import { DevicesView } from './devices-view';

export const DevicesPanel: FC = () => (
  <div className="pt-4">
    <DevicesView />
  </div>
);
